(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bt-cart-upsell"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bt-cart-upsell')) {
    customElements.define('bt-cart-upsell', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input[type="checkbox"]');
        this.choice = this.querySelector('.bt-cart-upsell__choice');
        this.status = this.querySelector('[role="status"]');
        this.input?.addEventListener('change', () => this.updateCart());
      }

      async updateCart() {
        const adding = this.input.checked;
        const root = window.Shopify?.routes?.root || '/';
        const endpoint = adding ? `${root}cart/add.js` : `${root}cart/change.js`;
        const body = adding
          ? { items: [{ id: Number(this.dataset.variantId), quantity: 1 }] }
          : { id: this.dataset.lineKey, quantity: 0 };

        this.choice.classList.add('is-loading');
        this.input.disabled = true;
        this.status.textContent = adding ? 'Agregando el Pack Tendencias…' : 'Quitando el Pack Tendencias…';

        try {
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body)
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'No se pudo actualizar el carrito');
          window.location.reload();
        } catch (error) {
          this.input.checked = !adding;
          this.input.disabled = false;
          this.choice.classList.remove('is-loading');
          this.status.textContent = error.message || 'No pudimos actualizar el carrito. Intentá nuevamente.';
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bt-landing-order-bump"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.currentScript?.closest('.shopify-section')?.querySelector('.bt-order-bump-section') || document.querySelector('.bt-order-bump-section');
    if (!section || window.btDirectCheckoutReady) return;
    window.btDirectCheckoutReady = true;

    const bump = section.querySelector('[data-bt-order-bump]');
    const checkbox = section.querySelector('[data-bt-order-bump-checkbox]');
    const status = section.querySelector('[role="status"]');
    const mainVariantId = Number(section.dataset.mainVariantId);
    const bonusVariantId = Number(section.dataset.bonusVariantId);
    const mainPrice = section.dataset.mainPrice || '';
    const combinedPrice = section.dataset.combinedPrice || '';
    let stickyCheckbox = null;
    let stickyPrice = null;
    let stickyButtonLabel = null;
    let stickyButtonNote = null;
    let defaultStickyLabel = null;
    let defaultStickyNote = null;

    const syncStickyState = (checked) => {
      if (checkbox) checkbox.checked = checked;
      if (stickyCheckbox) stickyCheckbox.checked = checked;

      const sticky = document.querySelector('.bt-guarantee__sticky');
      sticky?.classList.toggle('is-pack-selected', checked);

      if (stickyPrice) stickyPrice.textContent = checked ? combinedPrice : mainPrice;
      if (stickyButtonLabel) stickyButtonLabel.textContent = checked ? 'Comprar todo' : (defaultStickyLabel || 'Obtener mi biblioteca');
      if (stickyButtonNote) stickyButtonNote.textContent = checked ? 'Biblioteca + Pack' : (defaultStickyNote || '');

      const stickyText = sticky?.querySelector('[data-bt-sticky-bump-text]');
      if (stickyText) stickyText.textContent = checked ? '✓ Pack Tendencias agregado' : 'Sumá Pack Tendencias';
    };

    const setupStickyBump = () => {
      if (window.Shopify?.designMode) return;
      const sticky = document.querySelector('.bt-guarantee__sticky');
      const template = section.querySelector('[data-bt-sticky-bump-template]');
      if (!sticky || !template) return;

      if (!sticky.querySelector('[data-bt-sticky-bump]')) {
        sticky.prepend(template.content.cloneNode(true));
      }

      stickyCheckbox = sticky.querySelector('[data-bt-sticky-bump-checkbox]');
      stickyPrice = sticky.querySelector(':scope > div:not(.bt-sticky-bump) > strong');
      stickyButtonLabel = sticky.querySelector('form button strong');
      stickyButtonNote = sticky.querySelector('form button span');

      if (defaultStickyLabel === null) defaultStickyLabel = stickyButtonLabel?.textContent?.trim() || 'Obtener mi biblioteca';
      if (defaultStickyNote === null) defaultStickyNote = stickyButtonNote?.textContent?.trim() || '';

      if (stickyCheckbox && stickyCheckbox.dataset.bound !== 'true') {
        stickyCheckbox.dataset.bound = 'true';
        stickyCheckbox.addEventListener('change', () => syncStickyState(stickyCheckbox.checked));
      }

      syncStickyState(Boolean(checkbox?.checked));
    };

    const resetDirectCheckoutButtons = () => {
      document.querySelectorAll('.pd-market__form button[aria-busy="true"], .bt-guarantee__form button[aria-busy="true"], .bt-guarantee__sticky form button[aria-busy="true"]').forEach((button) => {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
      if (status) status.textContent = '';
    };

    const placeBump = () => {
      if (window.Shopify?.designMode) return;
      const form = document.querySelector('.pd-market__form');
      if (!form || !bump) return;
      section.classList.add('is-injected');
      form.before(section);
    };

    const directCheckout = async (form) => {
      const button = form.querySelector('button[type="submit"]');
      if (!button || button.disabled || button.getAttribute('aria-busy') === 'true') return;
      const root = window.Shopify?.routes?.root || '/';
      const items = [{ id: mainVariantId, quantity: 1 }];
      if (checkbox?.checked) items.push({ id: bonusVariantId, quantity: 1 });

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (status) status.textContent = '';

      try {
        const clearResponse = await fetch(`${root}cart/clear.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' }
        });
        if (!clearResponse.ok) throw new Error('No pudimos preparar el pedido. Intentá nuevamente.');

        const addResponse = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!addResponse.ok) throw new Error('No pudimos preparar el pedido. Intentá nuevamente.');
        window.location.assign(`${root}checkout`);
      } catch (error) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (status) status.textContent = error.message || 'No pudimos iniciar el pago. Intentá nuevamente.';
      }
    };

    checkbox?.addEventListener('change', () => syncStickyState(checkbox.checked));

    placeBump();
    resetDirectCheckoutButtons();

    const bootStickyBump = () => {
      setupStickyBump();
      syncStickyState(Boolean(checkbox?.checked));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootStickyBump, { once: true });
    } else {
      bootStickyBump();
    }

    window.addEventListener('pageshow', () => {
      resetDirectCheckoutButtons();
      setupStickyBump();
      syncStickyState(Boolean(checkbox?.checked));
    });

    document.addEventListener('shopify:section:load', () => {
      placeBump();
      setupStickyBump();
      syncStickyState(Boolean(checkbox?.checked));
    });

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('.pd-market__form, .bt-guarantee__form, .bt-guarantee__sticky form');
      if (!form || window.Shopify?.designMode) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      directCheckout(form);
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
